import React, { useContext } from "react";
var ListTypeContext = /*#__PURE__*/React.createContext();
export var ListTypeProvider = ListTypeContext.Provider;

function useListType() {
  var listInfo = useContext(ListTypeContext);

  var _ref = listInfo !== null && listInfo !== void 0 ? listInfo : {
    type: null,
    variant: null
  },
      type = _ref.type,
      variant = _ref.variant;

  return {
    type: type,
    variant: variant
  };
}

export default useListType;